import { ChangeEvent } from 'react';
import { Pagination as MuiPagination, styled } from '@mui/material';

const StyledPagination = styled(MuiPagination)({
  ul: { justifyContent: 'center' },
});

type PropsType = {
  page: number;
  totalPages?: number;
  onPageChange?: (value: number) => void;
};

export const PaginationWithoutParams = ({ totalPages, onPageChange, page }: PropsType) => {
  const handlePageChange = (_: ChangeEvent<unknown>, value: number) => {
    onPageChange && onPageChange(value);
  };
  return (
    <StyledPagination
      count={totalPages}
      page={page}
      color='primary'
      variant='outlined'
      onChange={handlePageChange}
    />
  );
};
